import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";

const faqs = [
  {
    question: "What is a Cryptfluencer?",
    answer: "A Cryptfluencer is the lovechild of a motivational speaker and a late-night infomercial host—armed with buzzwords like \"decentralized,\" \"moonshot,\" and \"diamond hands.\" They're the type to wear designer sneakers while livestreaming their \"biggest trade ever,\" only to mysteriously disappear during a market crash. With an uncanny ability to sell you a dream (or a dud token), they've mastered the art of mogging, shilling, and blaming \"the whales\" when things go south. In short, they're your digital tour guide to financial chaos—complete with a side of memes and mild panic. 😂"
  },
  {
    question: "What characters are apart of the cryfluencer universe?",
    answer: "The Cryptfluencer universe features a cast of notorious characters that will be revealed on mint day. Each character represents a unique archetype in the crypto world, from market manipulators to luxury lifestyle influencers. Stay tuned for the big reveal!"
  },
  {
    question: "How many NFTs are available?",
    answer: "The total supply varies by blockchain: Base (121), PulseChain (555), and Chia (9,324), for a total of 10,000 unique NFTs across all chains."
  },
  {
    question: "What are the minting prices?",
    answer: "Minting prices vary by chain: Base (0.0012 ETH), PulseChain (3 PLS), and Chia (0.2 XCH). These prices are set to ensure accessibility across different networks."
  },
  {
    question: "Can I mint multiple NFTs?",
    answer: "Yes, you can mint up to 10 NFTs per transaction. This limit helps ensure fair distribution among collectors."
  },
  {
    question: "Are the NFTs different on each chain?",
    answer: "While the same characters appear across chains, each blockchain's collection has unique traits and variations, making them distinct collectibles."
  },
  {
    question: "What wallets are supported?",
    answer: "We support all major Web3 wallets including MetaMask, WalletConnect, Coinbase Wallet, and chain-specific wallets for each network."
  },
  {
    question: "What happens after minting?",
    answer: "After minting, your NFT will appear in your wallet and can be viewed on the respective chain's NFT marketplaces. Metadata and images are stored on IPFS for permanence."
  },
  {
    question: "Are there secondary royalties?",
    answer: "Yes, there is a 5% royalty on secondary sales. These funds help support ongoing development and community initiatives."
  }
];

export default function FAQ() {
  return (
    <Layout>
      <div className="prose prose-invert max-w-4xl mx-auto">
        <h1 className="text-2xl font-pixel mb-8 text-[#9333EA]">Frequently Asked Questions</h1>
        <div className="space-y-8 text-xs leading-relaxed text-gray-400">
          {faqs.map((faq, index) => (
            <section key={index}>
              <h2 className="text-base font-pixel mb-4 text-[#9333EA]">{faq.question}</h2>
              <p className="mb-4">{faq.answer}</p>
            </section>
          ))}
        </div>

        <div className="mt-12 p-6 bg-black/50 border border-white/10 rounded-lg backdrop-blur-sm">
          <h2 className="text-lg font-bold mb-3 text-[#9333EA]">Still have questions?</h2>
          <p className="text-gray-400">
            Can't find the answer you're looking for? Please visit our{" "}
            <Link to="/support" className="text-[#9333EA] hover:text-[#9333EA]/80 transition-colors">
              Support Page
            </Link>
            .
          </p>
        </div>
      </div>
    </Layout>
  );
} 